import { radioAnatomy as parts } from '@chakra-ui/anatomy';
import { runIfFn } from '@chakra-ui/shared-utils';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system';

import { Checkbox } from './checkbox';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyleControl = defineStyle((props) => {
  const controlStyle = runIfFn(Checkbox.baseStyle, props)?.control;

  return {
    ...controlStyle,
    borderRadius: 'full',

    _checked: {
      ...controlStyle?.['_checked'],
      bgColor: 'current',
      borderColor: 'accent.default',

      _hover: {
        bgColor: 'current',
        borderColor: 'accent.default',
      },

      _before: {
        content: `""`,
        display: 'inline-block',
        pos: 'relative',
        w: '66%',
        h: '66%',
        borderRadius: '50%',
        bgColor: 'accent.default',
      },

      _disabled: {
        ...controlStyle?.['_checked']?._disabled,
        _before: {
          bgColor: 'transparent',
        },
      },
    },

    _disabled: {
      ...controlStyle?.['_disabled'],

      _hover: {
        borderColor: 'transparent',
      },
    },

    _invalid: {
      ...controlStyle?.['_invalid'],

      _hover: {
        borderColor: 'error.default',
      },
    },
  };
});

const baseStyle = definePartsStyle((props) => ({
  label: Checkbox.baseStyle?.(props).label,
  container: Checkbox.baseStyle?.(props).container,
  control: baseStyleControl(props),
}));

const sizes = {
  md: definePartsStyle({
    control: { w: '4', h: '4', _checked: { _before: { w: '2', h: '2' } } },
    label: { fontSize: 'md' },
  }),
  lg: definePartsStyle({
    control: { w: '5', h: '5' },
    label: { fontSize: 'lg' },
  }),
  sm: definePartsStyle({
    control: {
      width: '3.5',
      height: '3.5',
      _checked: { _before: { w: '7px', h: '7px' } },
    },
    label: { fontSize: 'sm' },
  }),
};

export const Radio = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: 'md',
    colorScheme: 'blue',
  },
});
